const offset = 35 // overlapping percentage

export function setImageOffsets(elements: HTMLElement[]) {
  const centerIndex = Math.floor(elements.length / 2)
  const globalOffset = elements.length % 2 === 0 ? -(offset / 2) : 0
  elements.forEach((elem, i) => {
    const diff = i === centerIndex ? 0 : Math.abs(i - centerIndex)
    const sign = i <= centerIndex ? 1 : -1
    const value = offset * sign * diff + globalOffset
    elem.style.setProperty('--x-offset', `${value}%`)
  })
}
